import type { LucideIcon } from "lucide-react";
import { Breadcrumb } from "./Breadcrumb";

interface PageHeaderProps {
    icon: LucideIcon;
    title: string;
    subtitle?: string;
    /**
     * Texto kicker estático (acima do título). Se omitido, renderiza o
     * Breadcrumb na variante dark no mesmo lugar — economiza uma linha
     * fora do hero.
     */
    kicker?: string;
    right?: React.ReactNode;
}

export function PageHeader({
    icon: Icon,
    title,
    subtitle,
    kicker,
    right,
}: PageHeaderProps) {
    return (
        <div className="bg-gradient-to-br from-[#0f172a] to-[#1e293b] rounded-2xl p-6 text-white">
            <div className="flex items-start justify-between gap-4 flex-wrap">
                <div className="flex items-center gap-4 min-w-0">
                    <div className="bg-white/10 p-3 rounded-xl shrink-0">
                        <Icon className="w-6 h-6" />
                    </div>
                    <div className="min-w-0">
                        <div className="mb-0.5">
                            {kicker ? (
                                <p className="text-[11px] uppercase tracking-wider text-white/50">
                                    {kicker}
                                </p>
                            ) : (
                                <Breadcrumb variant="dark" />
                            )}
                        </div>
                        <h1 className="text-2xl font-bold">{title}</h1>
                        {subtitle && (
                            <p className="text-sm text-white/60 mt-0.5">
                                {subtitle}
                            </p>
                        )}
                    </div>
                </div>
                {right && <div className="flex items-center gap-3">{right}</div>}
            </div>
        </div>
    );
}
